import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { CognitoService } from '../../core/service/cognito.service';
import { ToastService } from 'src/app/toast/toast.service';
import { UserService } from 'src/app/core/service/user.service';
import { Config } from '../../core/config/config';
import { StripeService } from 'src/app/stripe/stripe.services';
import { IUser } from 'src/app/core/models/user.model';
import { AuthStorageService } from '../../core/service/auth-storage.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  standalone: false,
})
export class SignInComponent implements OnInit, OnDestroy {
  loading: boolean;
  user: IUser;
  currentSlide: number = 0;
  private slideInterval: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cognitoService: CognitoService,
    private toastService: ToastService,
    private readonly userService: UserService,
    private readonly stripeService: StripeService,
    private authStorage: AuthStorageService
  ) {
    this.loading = false;
    this.user = {} as IUser;
  }

  ngOnInit(): void {
    this.startSlideshow();
  }

  ngOnDestroy(): void {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  private startSlideshow(): void {
    this.slideInterval = setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % 3;
    }, 4000); 
  }

  public async signIn(): Promise<void> {
    this.loading = true;
    try {
      const result = await this.cognitoService.signIn(this.user);

      if (result.isSignedIn && result.nextStep.signInStep === 'DONE') {
        const userData = result.user || {};
        const loginResponse = await firstValueFrom(
          this.userService.loginUser()
        );

        const mergedData = { ...userData, ...(loginResponse || {}) };
        this.authStorage.setItem('user', mergedData);
        this.user = mergedData;
        await this.router.navigate(['/'], { replaceUrl: true });
        this.userService.getUser().subscribe();
      }
    } catch (err: any) {
      console.error('Sign-in error:', err);
      if (err.code === 'UserNotConfirmedException') {
        this.toastService.showError(
          'Error',
          `${err.message}. Please sign up again`
        );
      } else {
        this.toastService.showError('Error', err.message);
      }
    } finally {
      this.loading = false;
    }
  }
}
